import { apiData, apiRequest } from "./http.js";

// I02：首页/当前主线进度
export async function getGameHome() {
  return apiData(await apiRequest("/api/game/home"));
}

// Map fragment collection
export async function getGameMap() {
  return apiData(await apiRequest("/api/game/map"));
}

// I03: continue main campaign
export async function startCampaign() {
  return apiData(await apiRequest("/api/game/campaign/start", { method: "POST" }));
}

// I04：历史关卡列表
export async function getHistoryLevels() {
  return apiData(await apiRequest("/api/game/campaign/history-levels"));
}

// I05：开始某个已允许进入的历史关卡
export async function startHistoryLevel(levelNo) {
  return apiData(await apiRequest(`/api/game/campaign/history-levels/${levelNo}/start`, {
    method: "POST"
  }));
}

// I06：结束一局。result: passed | failed | exited
export async function beginPlay(playId) {
  return apiData(
    await apiRequest(
      `/api/game/plays/${encodeURIComponent(playId)}/begin`,
      {
        method: "POST"
      }
    )
  );
}


export async function usePlaySkill(
  playId,
  skillType
) {
  return apiData(
    await apiRequest(
      `/api/game/plays/${encodeURIComponent(
        playId
      )}/skills/use`,
      {
        method: "POST",
        body: {
          skill_type:
            String(
              skillType || ""
            )
        }
      }
    )
  );
}


export async function finishPlay(
  playId,
  {
    result,
    score = 0,
    fragmentCollected = false
  } = {}
) {
  return apiData(
    await apiRequest(
      `/api/game/plays/${encodeURIComponent(playId)}/finish`,
      {
        method: "POST",
        body: {
          result,
          score: Math.max(
            0,
            Math.round(Number(score) || 0)
          ),
          fragment_collected: Boolean(
            fragmentCollected
          )
        }
      }
    )
  );
}



export async function getScenicCatalog() {
  return apiData(
    await apiRequest(
      "/api/game/scenic-maps"
    )
  );
}
